import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const AirportGateIcon = createIcon({
    viewBox: '0 0 20 20',
    path: (
        <Path
            fillRule='evenodd'
            fill='currentColor'
            d='M17.99 9.924a1.16 1.16 0 0 1-.132.892 1.175 1.175 0 0 1-.721.55l-7.63 2.05-4.194 1.1-1.252.38-2.088-3.549 1.158-.303 1.556 1.176 3.929-1.024L5.35 5.52l1.519-.417 5.446 5.086 4.232-1.12c.317-.088.617-.047.902.123.285.171.465.415.54.731z'
        />
    ),
})

AirportGateIcon.displayName = 'AirportGateIcon'
